import axios from "axios";

const hostname = window.location.hostname.toLowerCase();

const DEV_DOMAINS = ["localhost", "gtbuilder.io", "svtrainings.info"];

const isDevHost = DEV_DOMAINS.some(
  (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
);

const baseURL = isDevHost
  ? "https://be-dev.swishbuilder.io"
  : "https://be-prod.swishbuilder.io";

export const axiosClient = axios.create({
  baseURL,
  timeout: 30 * 60 * 1000,
  headers: {
    "Content-Type": "application/json",
  },
});
